<template>
<main class="content">
  <SectionAboutTeam/>
  <SectionAboutUs/>
  <SectionTeam/>
  <SectionRequest/>
</main>
</template>

<script>
import SectionAboutTeam from "@/components/SectionAboutTeam";
import SectionAboutUs from "@/components/SectionAboutUs";
import SectionTeam from "@/components/SectionTeam";
import SectionRequest from "@/components/SectionRequest";
export default {
  name: 'Company',
  components: {
    SectionAboutTeam,
    SectionAboutUs,
    SectionTeam,
    SectionRequest
  },
  methods: {
  },
  computed: {
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.content {
  background-color: #eee;
}
</style>
